import { render, staticRenderFns } from "./RecuperarSenhaConfirm.vue?vue&type=template&id=7f699f87&"
import script from "./RecuperarSenhaConfirm.vue?vue&type=script&lang=js&"
export * from "./RecuperarSenhaConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports